export { default } from './RelatedRecordsContent';
